<template>
  <div>
    <legend>Отчет №4</legend>
    <!--    <pre>-->
    <!--      {{ summaries.paidAmountByDateAndPaymentType }}-->
    <!--    </pre>-->
    <div class="form-group row mx-auto sticky-top py-3 bg-white" style="max-width: 600px">
      <div class="col">
        <date-picker v-model="from" :first-day-of-week="1" :input-attr="{required: true}"
                     class="w-100"
                     input-class="form-control"
                     lang="ru"
                     placeholder="С" valueType="format">
        </date-picker>
      </div>
      <div class="col">
        <date-picker v-model="to" :first-day-of-week="1" :input-attr="{required: true}"
                     class="w-100"
                     input-class="form-control"
                     lang="ru"
                     placeholder="По" valueType="format">
        </date-picker>
      </div>
      <div class="col">
        <button class="btn btn-outline-info" @click="setPrevWeek">Назад</button>
        <button class="ml-3 btn btn-outline-info" @click="setNextWeek">Вперед</button>
      </div>
    </div>
    <div class="overflow-auto stats4-table-wrapper">
      <transition name="fade">
        <table v-if="isLoadedSummaries" class="table table-bordered table-sm text-center small table-hover">
          <thead>
            <tr>
              <th rowspan="2">Отчетная дата</th>
              <th rowspan="2">Категория</th>
              <th colspan="5">Отправлено с производства</th>
              <th colspan="2">Доставлено изделий</th>
              <th v-for="(pt, ptId) in report.paymentTypes" colspan="2">
                Оплачено изделий, {{ pt }}
              </th>
            </tr>
            <tr>
              <th>
                шт.
              </th>
              <template v-for="pt in report.paymentTypes">
                <th>{{ pt }}, руб.</th>
              </template>
              <th>Кол-во (шт.)</th>
              <th>Сумма руб.</th>
              <template v-for="(pt, ptId) in report.paymentTypes">
                <th>Кол-во (шт.)</th>
                <th>Сумма руб.</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-for="d in report.dates">
              <tr v-for="(cc, ccId) in report.customerCategories">
                <td v-if="ccId == 1" rowspan="5">{{ d }}</td>
                <td>{{ cc }}</td>
                <td>{{ summaries.dispatchAmountByDateAndCc[d][ccId] || '' }}</td>
                <template v-for="(pt, ptId) in report.paymentTypes">
                  <td>{{ getDispatchPtSummary(d, ccId, ptId) }}</td>
                </template>
                <td>{{ getDeliveryPtAmount(d, ccId) }}</td>
                <td>{{ getDeliveryPtSummary(d, ccId) }}</td>
                <template v-for="(pt, ptId) in report.paymentTypes">
                  <td>{{ getAmountByPtId_d_ccId(ptId, d, ccId) || '' }}</td>
                  <td>{{ getSummaryByPtId_d_ccId(ptId, d, ccId) || '' }}</td>
                </template>
              </tr>
              <tr>
                <td class="font-weight-bold text-black-50">Итого</td>
                <td>{{ summaries.dispatchAmountByDate[d] || '' }}</td>
                <template v-for="(pt, ptId) in report.paymentTypes">
                  <td>{{ summaries.dispatchSummaryByDateAndPt[d][ptId] || '' }}</td>
                </template>
                <td>{{ summaries.deliveredAmountByDate[d] || '' }}</td>
                <td>{{ summaries.deliveredSummaryByDate[d] || '' }}</td>
                <template v-for="(pt, ptId) in report.paymentTypes">
                  <td>{{ summaries.paidAmountByDateAndPaymentType[d][ptId] || '' }}</td>
                  <td>{{ summaries.paidSummaryByDateAndPaymentType[d][ptId] || '' }}</td>
                </template>
              </tr>
            </template>
            <tr class="font-weight-bold" style="background-color: #eee">
              <td></td>
              <td>Итого</td>
              <td>{{ summaries.dispatchAmountByDateAndCc_All || 0 }}</td>
              <template v-for="(pt, ptId) in report.paymentTypes">
                <td>{{ summaries.dispatchSummaryByDateAndPt_All[ptId] || 0 }}</td>
              </template>
              <td>{{ summaries.deliveredAmountByDate_All || 0 }}</td>
              <td>{{ summaries.deliveredSummaryByDate_All || 0 }}</td>
              <template v-for="(pt, ptId) in report.paymentTypes">
                <td>{{ summaries.paidAmountByPaymentType_All[ptId] || 0 }}</td>
                <td>{{ summaries.paidSummaryByPaymentType_All[ptId] || 0 }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </transition>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';
import $ from 'jquery';

// const defaultDateFrom = moment().subtract(7, 'days').format('YYYY-MM-DD');
// const defaultDateTo = moment().format('YYYY-MM-DD');

const today = moment();
const today1 = moment();
const fromDate = today.startOf('week').day(1);
const toDate = today1.endOf('week').day(7);

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      fromMaster: fromDate,
      toMaster: toDate,
      report: {},
      isLoaded: false,
    };
  },
  mounted() {
    this.fetchDayReport();
  },
  watch: {
    from(newVal) {
      this.report = {};
      if (newVal) {
        this.fetchDayReport();
      }
    },
    to(newVal) {
      this.report = {};
      if (newVal) {
        this.fetchDayReport();
      }
    },
    isLoadedSummaries: _.debounce((newVal) => {
      const $stats4TableWrapper = $('.stats4-table-wrapper');
      const height = $stats4TableWrapper.outerHeight();
      if (newVal) {
        $stats4TableWrapper.css({ height: 'auto' });
      } else {
        $stats4TableWrapper.css({ height });
      }
    }, 1),
  },
  computed: {
    from: {
      get() {
        return this.fromMaster.format('YYYY-MM-DD');
      },
      set(val) {
        if (!val) {
          this.fromMaster = fromDate;
        } else {
          this.fromMaster = moment(val);
        }
      },
    },
    to: {
      get() {
        return this.toMaster.format('YYYY-MM-DD');
      },
      set(val) {
        if (!val) {
          this.toMaster = toDate;
        } else {
          this.toMaster = moment(val);
        }
      },
    },
    isLoadedSummaries() {
      return !_.isEmpty(this.report, true);
    },
    summaries() {
      let result = {};
      const customerCategories = _.mapValues(this.report.customerCategories, () => 0);
      const paymentTypes = _.mapValues(this.report.paymentTypes, () => 0);
      const dates = _.mapValues(_.invert(this.report.dates), () => 0);

      let dispatchSummaryByDateAndPt = _.clone(dates);
      dispatchSummaryByDateAndPt = _.mapValues(dispatchSummaryByDateAndPt,
        () => _.clone(paymentTypes));

      let dispatchAmountByDateAndCc = _.clone(dates);
      dispatchAmountByDateAndCc = _.mapValues(dispatchAmountByDateAndCc,
        () => _.clone(customerCategories));

      const dispatchAmountByDate = _.clone(dates);


      _.each(this.report.dispatch, (day, date) => {
        dispatchSummaryByDateAndPt[date] = _.mapValues(dispatchSummaryByDateAndPt[date],
          (ptName, pTypeId) => _.sum(
            _.map(this.report.dispatch[date],
              ccDay => (ccDay[pTypeId] ? ccDay[pTypeId].OrderItemSummary : 0)),
          ));

        dispatchAmountByDateAndCc[date] = _.mapValues(
          dispatchAmountByDateAndCc[date],
          (ccName, ccId) => _.sum(
            _.map(this.report.dispatch[date][ccId], ccByPt => ccByPt.OrderItemAmount),
          ),
        );
        dispatchAmountByDate[date] = dispatchAmountByDateAndCc[date]
          ? _.sum(_.values(dispatchAmountByDateAndCc[date]))
          : 0;
      });

      // eslint-disable-next-line camelcase
      const dispatchAmountByDateAndCc_All = _.sum(
        _.values(
          _.mapValues(dispatchAmountByDateAndCc, day => _.sum(_.values(day))),
        ),
      );


      // eslint-disable-next-line camelcase
      let dispatchSummaryByDateAndPt_All = _.clone(paymentTypes);
      // eslint-disable-next-line camelcase
      dispatchSummaryByDateAndPt_All = _.mapValues(
        dispatchSummaryByDateAndPt_All, (pt, ptId) => _.sum(
          _.values(
            _.mapValues(dispatchSummaryByDateAndPt, dispatchDay => dispatchDay[ptId]),
          ),
        ),
      );

      const deliveredAmountByDate = _.clone(dates);
      const deliveredSummaryByDate = _.clone(dates);

      _.each(this.report.dates, (date) => {
        deliveredAmountByDate[date] = this.report.delivered[date] !== undefined
          ? _.sum(_.map(this.report.delivered[date], del => del.OrderItemAmount))
          : 0;

        deliveredSummaryByDate[date] = this.report.delivered[date] !== undefined
          ? _.sum(_.map(this.report.delivered[date], del => del.OrderItemSummary))
          : 0;
      });

      // eslint-disable-next-line camelcase
      const deliveredAmountByDate_All = _.sum(_.values(deliveredAmountByDate));
      // eslint-disable-next-line camelcase
      const deliveredSummaryByDate_All = _.sum(_.values(deliveredSummaryByDate));


      let paidAmountByDateAndPaymentType = _.clone(dates);
      paidAmountByDateAndPaymentType = _.mapValues(paidAmountByDateAndPaymentType, () => _.clone(paymentTypes));

      let paidSummaryByDateAndPaymentType = _.clone(dates);
      paidSummaryByDateAndPaymentType = _.mapValues(paidSummaryByDateAndPaymentType, () => _.clone(paymentTypes));


      _.each(dates, (date, day) => {
        paidAmountByDateAndPaymentType[day] = _.mapValues(this.report.byPaymentType, (pt, PtId) => _.sum(_.values(_.mapValues(this.report.byPaymentType[PtId][day], (cc, ccId) => cc.OrderItemAmount))));
        paidSummaryByDateAndPaymentType[day] = _.mapValues(this.report.byPaymentType, (pt, PtId) => _.sum(_.values(_.mapValues(this.report.byPaymentType[PtId][day], (cc, ccId) => cc.OrderItemSummary))));
      });


      // eslint-disable-next-line camelcase
      let paidAmountByPaymentType_All = _.clone(paymentTypes);
      // eslint-disable-next-line camelcase
      paidAmountByPaymentType_All = _.mapValues(
        paidAmountByPaymentType_All, (pt, ptId) => _.sum(
          _.values(
            _.mapValues(paidAmountByDateAndPaymentType, dispatchDay => dispatchDay[ptId]),
          ),
        ),
      );

      // eslint-disable-next-line camelcase
      let paidSummaryByPaymentType_All = _.clone(paymentTypes);
      // eslint-disable-next-line camelcase
      paidSummaryByPaymentType_All = _.mapValues(
        paidSummaryByPaymentType_All, (pt, ptId) => _.sum(
          _.values(
            _.mapValues(paidSummaryByDateAndPaymentType, dispatchDay => dispatchDay[ptId]),
          ),
        ),
      );


      result = {
        paidAmountByPaymentType_All,
        paidSummaryByPaymentType_All,
        deliveredAmountByDate_All,
        deliveredSummaryByDate_All,
        dispatchSummaryByDateAndPt_All,
        dispatchAmountByDateAndCc_All,
        paidSummaryByDateAndPaymentType,
        paidAmountByDateAndPaymentType,
        deliveredSummaryByDate,
        deliveredAmountByDate,
        dispatchAmountByDate,
        dispatchAmountByDateAndCc,
        dispatchSummaryByDateAndPt,
      };
      return result;
    },
  },
  methods: {
    // sumDispatchAmountByPt(d, ccId) {
    //   if (!this.report.dispatch[d] || this.report.dispatch[d][ccId]) {
    //     return false;
    //   }
    // },
    setNextWeek() {
      this.fromMaster = moment(this.fromMaster).add(1, 'weeks');
      this.toMaster = moment(this.toMaster).add(1, 'weeks');
    },
    setPrevWeek() {
      this.fromMaster = moment(this.fromMaster).subtract(1, 'weeks');
      this.toMaster = moment(this.toMaster).subtract(1, 'weeks');
    },
    getDispatchPtSummary(d, ccId, ptId) {
      return this.report.dispatch[d]
      && this.report.dispatch[d][ccId]
      && this.report.dispatch[d][ccId][ptId] ? this.report.dispatch[d][ccId][ptId].OrderItemSummary : '';
    },
    getAmountByPtId_d_ccId(ptId, d, ccId) {
      return this.report.byPaymentType[ptId]
      && this.report.byPaymentType[ptId][d]
      && this.report.byPaymentType[ptId][d][ccId] ? this.report.byPaymentType[ptId][d][ccId].OrderItemAmount : '';
    },
    getSummaryByPtId_d_ccId(ptId, d, ccId) {
      return this.report.byPaymentType[ptId]
      && this.report.byPaymentType[ptId][d]
      && this.report.byPaymentType[ptId][d][ccId] ? this.report.byPaymentType[ptId][d][ccId].OrderItemSummary : '';
    },
    getDeliveryPtAmount(d, ccId) {
      return this.report.delivered[d]
      && this.report.delivered[d][ccId]
      && this.report.delivered[d][ccId] ? this.report.delivered[d][ccId].OrderItemAmount : '';
    },
    getDeliveryPtSummary(d, ccId) {
      return this.report.delivered[d]
      && this.report.delivered[d][ccId]
      && this.report.delivered[d][ccId] ? this.report.delivered[d][ccId].OrderItemSummary : '';
    },
    fetchDayReport: _.debounce(async function qqq() {
      this.isLoaded = false;
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/stats/stats4/${this.from}/${this.to}`);
      this.report = data;
      console.log(this.report);
      this.isLoaded = true;

      // _.debounce(() => {
      //
      // }, 100)
    }, 250),
  },
};
</script>
<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
